import { render, staticRenderFns } from "./PdfCreate.vue?vue&type=template&id=3badad82&scoped=true"
import script from "./PdfCreate.vue?vue&type=script&lang=js"
export * from "./PdfCreate.vue?vue&type=script&lang=js"
import style0 from "./PdfCreate.vue?vue&type=style&index=0&id=3badad82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3badad82",
  null
  
)

export default component.exports